<template>
    
    <b-modal title="Sign In" v-model="loginDialog" centered no-close-on-esc no-close-on-backdrop hide-header-close hide-footer>
        <b-container fluid>

            <b-row class="my-1">
                <b-col sm="12" class="tw-p-1">
                    <b-form-input size="lg" v-model="payload.username" placeholder="Identity"></b-form-input>
                </b-col>
                <b-col sm="12" class="tw-p-1">
                    <b-form-input type="password" size="lg" v-model="payload.password" placeholder="Password" @keypress.enter="login()"></b-form-input>
                </b-col>
            </b-row>

        </b-container>

        <b-button class="mt-3" variant="primary" block size="lg" @click="login()">Sign In</b-button>
        <b-button class="mt-2" variant="outline-primary" block size="lg" @click="cancel()">Cancel</b-button>
        
        <div class="mt-3 text-center">
            <p class="tw-mt-8"><b-link @click="forgotPassword()">Forgot Password</b-link></p>
            <!-- <p>Don't have an account? <b-link @click="signUp()">Sign up</b-link></p> -->
        </div>
    </b-modal>
</template>

<script>
    import {
        HTTP
    } from '@/utilities/http-common';

    import {
        mapGetters,
        mapActions,
        mapState
    } from 'vuex';

    export default {
        props: {
            next: {
                type: String,
                default: ''
            }
        },
        data: () => ({
            payload: {
                username: '',
                password: '',
                grant_type: process.env.VUE_APP_GRANT_TYPE,
                client_id: process.env.VUE_APP_CLIENT_ID,
                client_secret: process.env.VUE_APP_CLIENT_SECRET
            },
            dialog: true,
            alert: false
        }),
        computed: {
            ...mapState('dialog', ['loginDialog']),
            ...mapGetters([
                'getAuthorizationToken',
                'getAuthorizationHeader',
                'hasAuthorizationToken'
            ])
        },
        methods: {
            ...mapActions(['setAuthorizationToken', 'setBaseComponent']),
            ...mapActions('dialog', ['hideLoginDialog']),
            ...mapActions('alert', ['setSuccess', 'setError']),
            ...mapActions('user', ['setUser', 'getUser']),
            login: function () {
                let that = this;
                that.alert = false;

                if (!that.$data.payload.username.trim() || !that.$data.payload.password.trim()) {
                    that.alert = true;
                    return;
                }

                // Attempt a login
                HTTP.post('/users/api/token/', that.$data.payload).then(response => {
                    // Set token, updated HTTP with the Authorization token and set the base component to the 'Back' template.
                    that.setAuthorizationToken(response.data);
                    
                    that.$notify({
                        text: 'You have been logged in',
                        duration: 10000,
                        type: 'success'
                    });

                    that.$store.dispatch('user/getMyGroups').then(res => {
                        that.$store.dispatch('user/setMyGroups', res.data);
                    });

                    // HTTP.defaults.headers.common['Authorization'] = 'test';
                    that.getUser().then(res => {
                        that.setUser(res.data);
                    }).catch(() => {}).finally(() => {
                        that.hide();

                        // Navigate to next if set, otherwise, go to user page.
                        if (that.$route.query.next) {
                            that.$router.push({
                                path: that.$route.query.next
                            });
                        } else {
                            that.$router.go();// Reload the page.
                        }
                    });
                }).catch(() => {
                    that.alert = true;
                    that.payload.password = "";
                });
            },
            hide: function () {
                this.payload.username = "";
                this.payload.password = "";
                this.alert = false;
                this.hideLoginDialog()
            },
            cancel: function () {
                this.hide();

                this.$router.push({
                    name: 'home'
                });
            },
            // forgotPassword: function () {
            //     this.hide();

            //     this.$router.push({
            //         name: 'forgot-password'
            //     });
            // },
            forgotPassword: function () {
                this.hide();
                window.location.href = `${process.env.VUE_APP_AXIOS_BASE_URL}/accounts/password/reset/`;
            },
            signUp: function () {
                this.hide();

                this.$router.push({
                    name: 'register'
                });
            },
            
        }
    }
</script>